// remove this when we fix the for.
/* eslint-disable jsx-a11y/label-has-for */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './TextAreaInput.css';

class TextInput extends Component {
  static defaultProps = {
    value: '',
    label: '',
    required: false,
    placeholder: '',
    description: '',
    errorText: '',
    className: '',
  };
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
  }
  handleChange({ target: { id, value } }) {
    const { onChange } = this.props;
    onChange(id, value);
  }
  handleBlur({ target: { id, value } }) {
    const { onValidate } = this.props;
    onValidate(id, value);
  }
  render() {
    const {
      id,
      name,
      label,
      required,
      value,
      description,
      placeholder,
      errorText,
      className,
    } = this.props;
    const validClass = errorText !== '' ? 'invalid' : '';

    return (
      <div className={className}>
        <label className="active" htmlFor={id}>
          {label}
          {required ? <span className="required">*</span> : null}
        </label>
        <textarea
          id={id}
          name={name}
          value={value}
          placeholder={placeholder}
          className={validClass}
          onChange={this.handleChange}
          onBlur={this.handleBlur}
        />
        {errorText !== '' ? <div className="error-message">{errorText}</div> : null}
        {description !== '' ? <div className="field-description">{description}</div> : null}
      </div>
    );
  }
}

TextInput.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  required: PropTypes.bool,
  placeholder: PropTypes.string,
  description: PropTypes.string,
  value: PropTypes.string,
  errorText: PropTypes.string,
  className: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  onValidate: PropTypes.func.isRequired,
};

export default TextInput;



// WEBPACK FOOTER //
// ./src/components/formElements/TextAreaInput.js